export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig()
  const { apiUrl, clientId, bucketName } = config.public
  const timeout = 60 * 1000
  let fastApiUrl = null

  // const $request = nuxtApp.$request
  // if (!$request) {
  //   throw Error('$request not found! Please check it is injected in plugins.')
  // }

  const url = `https://storage.googleapis.com/${bucketName}/site_resources/${clientId}/target/target.json`
  const hostTester = new HostTester(url, clientId)

  // $request.config.setApiURL(await hostTester.test())
  fastApiUrl = await hostTester.test()
  // $request.hosts = hostTester.hosts
  setInterval(async () => {
    // $request.config.setApiURL(await hostTester.test())
    fastApiUrl = await hostTester.test()
  }, timeout)

  return {
    provide: {
      hostTester,
      fastApiUrl
    }
  }
})

class HostTester {
  constructor(url, clientId) {
    this.url = url
    this.hosts = []
    this.clientId = clientId
  }

  async init() {
    const target = await fetch(this.url)
    const { host } = await target.json()
    this.hosts = host
  }

  async test() {
    try {
      if (this.hosts.length === 0) {
        await this.init()
      }
      const { url, index } = await Promise.any(
        this.hosts.map((url, i) => {
          return this.ping(url, i)
        })
      )
      console.info(`[Network] Host ${index} is chosen. (${url})`)
      return url
    } catch (error) {
      console.error('[Network] Host Test Fail.', error)
    }
  }

  async ping(url, index) {
    let ts, response
    try {
      ts = new Date().getTime()
      response = await fetch(`${url}/health?ts=${ts}&site=${this.clientId}`)
      return { url, index }
    } finally {
      const speed = new Date().getTime() - ts
      const status = !!response?.ok ? 'Success' : 'Failure'
      console.info(`[Network] Host: ${index}, URL: ${url}, Status: ${status}, Speed: ${speed}ms`)
    }
  }
}
